import { graphql } from '@gql';

export const BannerFragment = graphql(/* GraphQL */ `
  fragment HeroBannerFragment on VildarPageComponentsBanner {
    __typename
    banner {
      cta {
        external_link {
          href
          title
        }
        internal_linkConnection {
          edges {
            node {
              ... on VildarPage {
                navigation_title
                url
              }
            }
          }
        }
        label
      }
      headline
      image {
        alt_text
        crop_resize
        gravity
        imgConnection {
          ...SysAssetConnectionFragment
        }
      }
      layout
      paragraph
      rounded
      styled
      mobile_layout
      object_fit
      expand_image
      main_banner
    }
  }
`);
